import { FormType } from "@simplyk/common";
import { useWatch } from "react-hook-form";

import { scrollToTop } from "../../../../helpers/utils";
import { useFormV2Context } from "../../context/FormV2Context";

import { AmplitudeEvents } from "@/constants/amplitude";
import { MIN_DONATION_AMOUNT } from "@/features/FormV2/Step1/DonationForm/Amounts";
import { useAmplitude } from "@/hooks/amplitude/useAmplitude";

export const useDonationFirstStepSubmit = () => {
  const { logAmplitudeEvent } = useAmplitude();
  const { form, setCurrentStep, formObject: donationForm, setValidationMode } = useFormV2Context(FormType.DonationForm);

  const { trigger, control, watch } = form;

  const logDonorFormStepSubmitted = () => {
    logAmplitudeEvent(AmplitudeEvents.DonorFormStepSubmitted, {
      formId: donationForm.id,
      formType: donationForm.category,
      organizationCountry: donationForm.organization?.country,
    });
  };

  const donationAmount = watch("amount");
  const recurrence = useWatch({
    control,
    name: "recurrenceInterval",
  });

  const canSubmitFirstStep: boolean = donationAmount >= MIN_DONATION_AMOUNT;

  const onFirstStepSubmit = async () => {
    if (!canSubmitFirstStep) {
      return;
    }

    const isValid = await trigger(["amount", "addGiftAid", "hasGiftAidConfirmation"], {
      shouldFocus: true,
    });

    if (isValid) {
      scrollToTop("auto");
      setCurrentStep("payment");
      logDonorFormStepSubmitted();
      setValidationMode("onBlur");
    } else {
      setValidationMode("onChange");
    }
  };

  return { onFirstStepSubmit, canSubmitFirstStep, recurrence };
};
